module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.32812c9c.webp";